import { render, staticRenderFns } from "./SharesOperations.vue?vue&type=template&id=e82ab6fa&scoped=true&"
import script from "./SharesOperations.vue?vue&type=script&lang=js&"
export * from "./SharesOperations.vue?vue&type=script&lang=js&"
import style0 from "./SharesOperations.vue?vue&type=style&index=0&id=e82ab6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ab6fa",
  null
  
)

export default component.exports